import React from "react";

const HeadingTwo = props => {
  return <span className="heading2">{props.text}</span>;
};

export default HeadingTwo;
